import { createFeature, createReducer, on } from '@ngrx/store';
import { AuthActions } from './auth.actions';

export const AUTH_STATUS = {
  idle: 'idle',
  loading: 'loading',
  authenticated: 'authenticated',
  error: 'error',
} as const;

export type AuthStatus = (typeof AUTH_STATUS)[keyof typeof AUTH_STATUS];

export interface AuthState {
  uid: string | null;
  status: AuthStatus;
  error: string | null;
}

const initialState: AuthState = {
  uid: null,
  status: AUTH_STATUS.idle,
  error: null,
};

const reducer = createReducer(
  initialState,

  on(AuthActions.loginRequested, (state): AuthState => ({
    ...state,
    status: AUTH_STATUS.loading,
    error: null,
  })),

  on(AuthActions.loginSucceeded, (state, { uid }): AuthState => ({
    ...state,
    uid,
    status: AUTH_STATUS.authenticated,
    error: null,
  })),

  on(AuthActions.loginFailed, (state, { error }): AuthState => ({
    ...state,
    uid: null,
    status: AUTH_STATUS.error,
    error,
  })),

  on(AuthActions.logoutRequested, (state): AuthState => ({
    ...state,
    status: AUTH_STATUS.loading,
    error: null,
  })),

  on(AuthActions.logoutSucceeded, (): AuthState => ({
    ...initialState,
  })),

  on(AuthActions.logoutFailed, (state, { error }): AuthState => ({
    ...state,
    status: AUTH_STATUS.error,
    error,
  }))
);

export const authFeature = createFeature({
  name: 'auth',
  reducer,
});
